/**
 * Brush Integration - Connects BrushTool with LayerManager and existing Design Studio
 */

(function() {
    'use strict';

    // Wait for DOM and both managers to be ready
    document.addEventListener('DOMContentLoaded', function() {
        const studioElement = document.querySelector('[data-section-id]');
        if (!studioElement) return;
        
        const sectionId = studioElement.getAttribute('data-section-id');
        
        // Wait for layer manager to initialize
        const checkLayerManager = setInterval(() => {
            if (window.layerManager) {
                clearInterval(checkLayerManager);
                initializeBrushTool(sectionId);
            }
        }, 100);
        
        // Timeout after 5 seconds
        setTimeout(() => {
            clearInterval(checkLayerManager);
            if (!window.layerManager) {
                console.warn('LayerManager not found, brush tool may not work');
            }
        }, 5000);
    });

    function initializeBrushTool(sectionId) {
        const layerManager = window.layerManager;
        if (!layerManager) return;
        
        // Initialize BrushTool
        const brushTool = new BrushTool(sectionId, layerManager);
        window.brushTool = brushTool; // Make globally accessible
        
        // Get UI elements
        const addBrushLayerBtn = document.getElementById(`addBrushLayerBtn-${sectionId}`);
        const brushSizeSlider = document.getElementById(`brushSizeSlider-${sectionId}`);
        const brushOpacitySlider = document.getElementById(`brushOpacitySlider-${sectionId}`);
        const brushSmoothingSlider = document.getElementById(`brushSmoothingSlider-${sectionId}`);
        const brushColorBtn = document.getElementById(`brushColorBtn-${sectionId}`);
        const brushColorPreview = document.getElementById(`brushColorPreview-${sectionId}`);
        
        // Add Brush Layer Button
        if (addBrushLayerBtn) {
            addBrushLayerBtn.addEventListener('click', () => {
                const layerId = brushTool.createBrushLayer();
                layerManager.selectLayer(layerId);
                brushTool.activateBrush();
            });
        }
        
        // Brush Size Slider
        if (brushSizeSlider) {
            brushSizeSlider.addEventListener('input', (e) => {
                brushTool.setBrushSize(parseInt(e.target.value));
            });
        }
        
        // Brush Opacity Slider
        if (brushOpacitySlider) {
            brushOpacitySlider.addEventListener('input', (e) => {
                brushTool.setBrushOpacity(parseInt(e.target.value));
            });
        }
        
        // Brush Smoothing Slider
        if (brushSmoothingSlider) {
            brushSmoothingSlider.addEventListener('input', (e) => {
                brushTool.setBrushSmoothing(parseInt(e.target.value) / 100);
            });
        }
        
        // Brush Color Button - integrate with existing color picker
        if (brushColorBtn) {
            brushColorBtn.addEventListener('click', () => {
                // Get current selected color from text color picker
                const hexInput = document.getElementById(`hexInput-${sectionId}`);
                if (hexInput && hexInput.value) {
                    brushTool.setBrushColor(hexInput.value);
                } else {
                    // Default to black
                    brushTool.setBrushColor('#000000');
                }
            });
        }
        
        // Sync brush color with text color picker changes
        const hexInput = document.getElementById(`hexInput-${sectionId}`);
        if (hexInput) {
            const syncBrushColor = () => {
                if (brushTool.activeTool === 'brush' && hexInput.value) {
                    brushTool.setBrushColor(hexInput.value);
                }
            };
            
            hexInput.addEventListener('input', syncBrushColor);
            hexInput.addEventListener('change', syncBrushColor);
        }
        
        // Update brush controls visibility based on active tool
        const updateBrushControlsVisibility = () => {
            const brushControlsPanel = document.getElementById(`brushControlsPanel-${sectionId}`);
            if (brushControlsPanel) {
                if (brushTool.activeTool === 'brush' || brushTool.activeTool === 'eraser') {
                    brushControlsPanel.style.display = 'block';
                } else {
                    brushControlsPanel.style.display = 'none';
                }
            }
        };
        
        // Override activate/deactivate to update UI
        const originalActivateBrush = brushTool.activateBrush.bind(brushTool);
        brushTool.activateBrush = function() {
            originalActivateBrush();
            updateBrushControlsVisibility();
        };
        
        const originalActivateEraser = brushTool.activateEraser.bind(brushTool);
        brushTool.activateEraser = function() {
            originalActivateEraser();
            updateBrushControlsVisibility();
        };
        
        const originalDeactivate = brushTool.deactivate.bind(brushTool);
        brushTool.deactivate = function() {
            originalDeactivate();
            updateBrushControlsVisibility();
        };
        
        // Initial state
        updateBrushControlsVisibility();
        
        console.log('✅ Brush Integration initialized');
    }
})();

